module.exports = __webpack_public_path__ + "static/media/del_internet.2f1620ac.jpg";